// src/data/toolkitTools.js — what is in the toolkit, and which module it serves.
//
// Every tool belongs to a Dive In module and uses that module's own material
// (see data/toolkitData.js). Tools for modules 5 to 8 are still to be built.
import { ListChecks, MessageCircle, Mic, Users } from 'lucide-react';

export const TOOLKIT_TOOLS = [
  {
    id: 'story-style-finder',
    name: 'Family story style finder',
    moduleId: 1,
    moduleTitle: 'Why Family Stories Matter',
    blurb: 'Work out how your family already tells its stories, what that is good at, and what it tends to miss.',
    icon: Users,
    minutes: 5,
  },
  {
    id: 'interview-kit',
    name: 'Interview kit',
    moduleId: 2,
    moduleTitle: 'Become the Family Story Detective',
    blurb: 'Build a question sheet for one relative, with the GENTLE steps and what to do if it wanders.',
    icon: Mic,
    minutes: 10,
  },
  {
    id: 'ingredients-checker',
    name: 'Five ingredients checker',
    moduleId: 3,
    moduleTitle: 'The Five Story Ingredients',
    blurb: 'Write a story as you tell it now, then see which of the five ingredients it is missing.',
    icon: ListChecks,
    minutes: 10,
  },
  {
    id: 'question-deck',
    name: 'Dinner question deck',
    moduleId: 4,
    moduleTitle: 'Become the Family Conversation Catalyst',
    blurb: 'Deal three questions to take to the table tonight, from the five kinds that invite a story.',
    icon: MessageCircle,
    minutes: 3,
  },
];

export const getToolkitTool = (id) => TOOLKIT_TOOLS.find((tool) => tool.id === id) || null;

// Hand-off so the Vibe check results can open a tool rather than the list.
// The toolkit page reads it once, on mount.
const OPEN_TOOL_KEY = 'story-threads-vibe_open_tool';

export const openToolkitTool = (setCurrentView, toolId) => {
  try {
    sessionStorage.setItem(OPEN_TOOL_KEY, toolId);
  } catch {
    /* storage unavailable: the list still opens */
  }
  setCurrentView('toolkit');
};

export const consumeOpenToolkitTool = () => {
  try {
    const id = sessionStorage.getItem(OPEN_TOOL_KEY);
    sessionStorage.removeItem(OPEN_TOOL_KEY);
    return getToolkitTool(id) ? id : null;
  } catch {
    return null;
  }
};
